const ssc = (data, ballindex) => {
  let list = Vue => {
    let arr1 = [
      {
        title: '期间',
        align: 'center',
        className: `table_issueId`,
        width: 400,
        render: (h, { row }) => {
          return (
            <div>
              {/* <span>{row.date}</span> */}
              <span>{` ${row.beginIssue.substring(row.beginIssue.length - 6)} - ${row.endIssue.substring(row.endIssue.length - 6)}`}</span>
            </div>
          );
        }
      },
      {
        title: '',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              单<span>{row[ballindex]['single'] || 0}</span>/双
              <span>{row[ballindex]['double'] || 0}</span>
            </div>
          );
        }
      },
      {
        title: '',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              大<span>{row[ballindex]['big'] || 0}</span>/小
              <span>{row[ballindex]['small'] || 0}</span>
            </div>
          );
        }
      }
    ];
    let arr = [
      {
        title: '日期',
        align: 'center',
        className: `table_issueId`,
        width: 400,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row.date}</span>
              <span>{` ${row.beginIssue} - ${row.endIssue} 期`}</span>
            </div>
          );
        }
      },
      {
        title: '单',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['single'] || 0}</span>
            </div>
          );
        }
      },
      {
        title: '双',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['double'] || 0}</span>
            </div>
          );
        }
      },
      {
        title: '大',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['big'] || 0}</span>
            </div>
          );
        }
      },
      {
        title: '小',
        align: 'center',
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div>
              <span>{row[ballindex]['small'] || 0}</span>
            </div>
          );
        }
      }
    ];
    if (Vue.showMobile) {
      return arr1;
    } else {
      return arr;
    }
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Liangmianshujutongji/columns/ssc.js